module.exports = __webpack_public_path__ + "static/media/29090003-iVT0wSgs.56c1a5d6.JPG";